export enum AuctionStatusEnum {
    Default = 0,
    Open = 1,
    Closed = 2,
    Awaiting = 3
}